(function () {
    'use strict';
    var controllerId = 'convAnnulled';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', 'bootstrap.dialog', '$uibModalInstance', 'convenzione', 'isSuper', convAnnulled]);

    function convAnnulled($scope, datacontext, bDialog, $uibModalInstance, convenzione, isSuper) {
        $scope.convenzione = jQuery.extend({}, convenzione); //Clona oggetto
        $scope.nominativo = $scope.convenzione.Accred_L_CodiceFiscale;
        $scope.isSuper = isSuper;

        if (!isSuper || typeof isSuper == undefined || typeof isSuper == 'undefined' || isSuper == null) {
            $scope.isSuper = false;
        }

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.openCalendar = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            if (iOpened == 1)
                $scope.opened1 = true;
        };

        $scope.ok = function (isValid, bSpecialAnnulled) {
            if (isValid) {
                var result = addItem($scope.convenzione, bSpecialAnnulled);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item, bSpecialAnnulled) {
            if (!bSpecialAnnulled) {
                return datacontext.cndConvenzione_setAnnulled(item.Id, true, $scope.noteAnnulled).then(function (data) {
                    return data;
                });
            }
            else {
                return bDialog.confirmationDialog('Attenzione', 'Stai effettuando l\'annullamento speciale. Procedere? ', 'Ok').then(
                    function () { //YES
                        return datacontext.cndConvenzione_specialAnnulled(item.Id, $scope.noteAnnulled).then(function (data) {
                            return data;
                        });
                    },
                    function () { //NO
                        //
                    }
                );
            }
        }

    }
})();